'use client';

import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

import { useCheckSpotOnly } from '@flipster/features/src/shared/regulation';
import { IsomorphicLink } from '@flipster/react/design-utils/isomorphic-link';
import { css } from '@flipster/styled-system/css';
import { alert } from '@flipster/utils/alert';

import RewardBox from './reward-box.svg';
import { useRewardHubPopUp } from './useRewardHubPopUp';

interface Props {
  onClose: VoidFunction;
}

const RewardHubPopUp = ({ onClose }: Props) => {
  const router = useRouter();

  const isSpotOnly = useCheckSpotOnly();
  const { isShowRewardHubAlert, closeRewardHubPopUp } = useRewardHubPopUp();

  useEffect(() => {
    if (!isShowRewardHubAlert || isSpotOnly) return;

    const handleClose = () => {
      onClose();
      closeRewardHubPopUp();
    };

    const onConfirm = () => {
      handleClose();
      router.push('/user/kyc');
    };

    const onClickLink = () => {
      handleClose();
      alert.clear();
    };

    alert.show({
      message: (
        <div className={css({ textAlign: 'center' })}>
          <RewardBox width={80} height={80} />
          <p className={css({ textStyle: 'Title/S', color: 'content.default.level-4', mt: 16 })}>
            Verify your Identity and
          </p>
          <p className={css({ textStyle: 'Title/S', color: 'content.default.level-4' })}>
            earn up to <strong className={css({ color: 'content.accent.info' })}>5 USDT*</strong>
          </p>
          <p className={css({ textStyle: 'Text/M/Regular', color: 'content.default.level-2', mt: 4 })}>
            *Finish all tasks to receive your reward in the{' '}
            <IsomorphicLink
              href='/reward-hub'
              onClick={onClickLink}
              className={css({ textStyle: 'Text/M/Underline', color: 'content.default.level-2' })}
            >
              Rewards Hub.
            </IsomorphicLink>
          </p>
        </div>
      ),
      confirmText: 'Verify now',
      closeText: 'Close',
      withClose: true,
      onConfirm,
      onClose: handleClose,
    });
  }, [closeRewardHubPopUp, isShowRewardHubAlert, onClose, router, isSpotOnly]);

  return null;
};

export default RewardHubPopUp;
